export const contactInfo = {
  contactAddress: "Brasov,Romania",
  defaultCity: "brasov", // Default city slug for category navigation

  phone: "0735 520 999",
  registeredOffice:
    "Jud. Brașov, Municipiul Brașov, Str. Baciului nr. 4, Biroul",
  CUI: "51955681",
  tradeSerialNumber: "J2025041841001",
  phoneFormatted: "+40735520999",
  contactEmail: "contact@eisservice.ro",
  clientEmail: "client@eisservice.ro",
  prestatorEmail: "contact@eisservice.ro",
  facebookPage: "https://www.facebook.com/eisservicecomplete",
  instagramPage: "https://www.instagram.com/eisservicecomplete/",
  tikTokPage: "https://www.tiktok.com/@eisservicecomplete",
  youtubePage: "https://www.youtube.com/channel/UCIj-bbdDuaUi9HFQd6J5BoQ",
  whatsUpNumber: "https://wa.me/40735520999",
};
